/*Kelvin Roger Ang Yap 2017
	krayap@gmail.com
*/
//import on files
Vue.component('kr-reset-password', require('./components/kr-reset-password.vue').default);
Vue.component('kr-calculator', require('./components/kr-calculator.vue').default);
Vue.component('test-status', require('./components/test-status.vue').default);
Vue.component('pdf-viewer', require('./components/pdf-viewer.vue').default);